module.exports = __webpack_public_path__ + "static/cashew_nuts_td_1-bd29767c4312674a05d5c41ebd4c2f39.jpg";